module.exports = __webpack_public_path__ + "static/media/inventory-audit-trail-icon.74f3c77f.svg";